<template>
  <div class="home">
    <div class="ani logo" swiper-animate-effect="fadeIn" swiper-animate-duration="0.5s">
       <a href="#home">
          <img src="../assets/logo.png">
       </a>
    </div>
    <div class="home-img ani" swiper-animate-effect="pulse" swiper-animate-duration="10s" ></div>
    <div class="home-mask">
      <!-- <div class="mask ani" swiper-animate-effect="fadeIn" swiper-animate-duration="0.5s"></div> -->
      <div class="home-text">
        <h1 class="ani" swiper-animate-effect="fadeInUp" swiper-animate-duration="1.5s">Together We Deliver</h1>
        <!-- <img src="../assets/title.png"> -->
        <p class="ani" swiper-animate-effect="fadeInUp" swiper-animate-duration="1.5s" swiper-animate-delay="0.3s">HUNICORN, YOUR LOGISTICS PARTNER IN CHINA.</p>
      </div>
      <div class="sail">
        <p>Start voyage</p>
        <a href="#about"><img class="ani" swiper-animate-effect="rotateIn" swiper-animate-duration="10s" src="../assets/sail.png"></a>
      </div>
    </div>
  </div>
</template>


<script>


export default {
  name: "home",
  data() {
    return {};
  },
  components: {
  }
};
</script>

<style>
@import 'bootstrap/dist/css/bootstrap.css';
@import 'bootstrap-vue/dist/bootstrap-vue.css';

.home {
  height: 100%;
  background-size: cover;
  padding: 30px 0 40px;
  box-sizing: border-box;
  /* margin-right: 30px; */
  position: relative;
  background: url(../assets/home_bg.jpg) no-repeat bottom;
  background-size: 100%;
  overflow: hidden;
}
.home-img{
  position: absolute;
  height: 100%;
  width: 100%;
  bottom: -4px;
  background: url(../assets/home_bg.jpg) no-repeat bottom;
  background-size: 100%;
}
.home-mask {
  background: rgba(4, 16, 53, 0.8);
  height: 100%;
  margin: 0 30px;
  text-align: center;
  position: relative;
}
.mask{
  /* background: url(../assets/mask.png) top; */
  /* background-size: 100%; */

  width: 100%;
  height: 100%;
}
.home-text {
  position: absolute;
  top: 35%;
  left: 50%;
  transform: translateX(-50%);
}
.home-text h1 {
  font-size: 84px;
  color: rgb(168, 190, 243);
}
.home-text p {
  font-size: 28px;
  color: #f4f4f4;
  max-width: 645px;
  margin: 20px auto;
}
.sail{
  position: absolute;
  bottom: 60px;
  left: 50%;
  transform: translateX(-50%);
}
.sail p{
    font-size: 20px;
    margin-bottom: 10px;
    color: #fff;
}
@media screen and (max-width: 1300px){
  .home-text h1{
    font-size: 60px;
  }
}
@media screen and (max-width: 992px) {
  .logo{
    left: 25px;
    top: 20px;
    width: 54px;
  }
  .logo img{
    width: 100%;
  }
  .home{
    padding: 0;
    background-size: 140%;
  }
  .home-img{
    background-size: 140%;
  }
    .home-mask{
    margin: 0;
  }
  .home-text{
    width: 100%;
  }
  .home-text h1{
    font-size: 32px;
  }
  .home-text p{
    font-size: 16px;
    padding: 0 40px;
  }
  
  .sail{
    bottom: 20px;
  }
  .sail p{
    font-size: 16px;
  }
  .footer{
    display: none;
  }
    
}
@media screen and (max-width: 776px) {
    .home,.home-img{
    background-size: 340%;
  }
}

</style>



// WEBPACK FOOTER //
// src/view/Home.vue